import { useSelector } from 'react-redux';

export function useSelectedOutcomeIds() {
  const selectedOutcomeIds = useSelector(state =>
    state.quickBet.isEnabled ? state.quickBet.selectedOutcomeIds : state.ticket.selectedOutcomeIds
  );

  return selectedOutcomeIds;
}
